// Protocol Basic — JS dla publicznego szablonu KB

// Kopiuj stronę jako Markdown (fetch .md endpoint)
window.copyEntryMarkdown = function(mdUrl, el) {
  if (!el) return;
  var orig = el.textContent;
  el.textContent = '...';
  fetch(mdUrl, { headers: { Accept: 'text/markdown' } })
    .then(function(r) { return r.text(); })
    .then(function(t) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(t);
      } else {
        var ta = document.createElement('textarea');
        ta.value = t; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select(); document.execCommand('copy');
        document.body.removeChild(ta);
      }
      el.textContent = 'Skopiowano!';
      setTimeout(function() { el.textContent = orig; }, 2000);
    });
};

// Zamykanie dropdown przy kliknięciu poza nim
document.addEventListener('click', function(e) {
  var dropdown = document.getElementById('entry-actions-dropdown');
  if (dropdown && !dropdown.contains(e.target)) {
    var menu = dropdown.querySelector('.entry-actions-menu');
    if (menu) menu.classList.add('hidden');
  }
});
